/**
 * Replace `%%` with `%` as `%%` is used as an escape in some translations
 * @param {String} translation 
 */
const replaceDoublePercentage = (translation) => {
    return translation.replace('%%', '%');
};

/**
 * Returns a translation from a given Crowdin key.
 * @param  {String} key - Crowdin key
 * @returns {String}
 */
const getTranslation = (key) => {
    return window.BUSUU_TRANSLATIONS[key] || 'NOT FOUND';
};

/**
 * Replaces a single ocurrence of %s in a given translation
 * @param {String} translation 
 * @param {String} arg 
 * @returns {String}
 */
const replaceTranslation = (translation, arg) => {
    if (!translation || !arg) {
        return translation;
    }

    const translationWithArgs = translation.replace('%s', arg);

    return replaceDoublePercentage(translationWithArgs);
};

/**
 * Replaces PHP %n$s from arguments where n is index + 1
 * in a given translation
 * @param  {String} translation - Translated Crowdin key
 * @param  {String[]} args - Args to inject
 * @returns {String}
 */
const replaceTranslationMulti = (translation, args = []) => {
    if (!translation || !args.length) {
        return translation;
    }

    const translationWithArgs =  args.reduce((trs, arg, index) => {
        return trs.replace(`%${index + 1}$s`, arg);
    }, translation);

    return replaceDoublePercentage(translationWithArgs);
};

/**
 * Returns a translation from a corwdin key and calls replaceTranslation
 * @param {String} key 
 * @param {String} args 
 * @returns {String}
 */
const getAndReplaceTranslation = (key, arg) => {
    return replaceTranslation(getTranslation(key), arg);
};

/**
 * Returns a translation from a crowdin key and calls replaceTranslationMulti
 * @param {String} key 
 * @param {String[]} args 
 * @returns {String}
 */
const getAndReplaceTranslationMulti = (key, args) => {
    return replaceTranslationMulti(getTranslation(key), args);
};

const TranslationsService = {
    getTranslation,
    getAndReplaceTranslation,
    getAndReplaceTranslationMulti,
    replaceTranslation,
    replaceTranslationMulti
};

export default TranslationsService;
